import { useReportTemplateContext } from "../ReportTemplate/ReportTemplateContext";

const GREEN = "#04aa00";
const LIGHT_GREY = "#f0f0f0";
const WHITE = "#ffffff";

export default function MelutasotBlock() {
  const { rakennusData: kiinteisto } = useReportTemplateContext();
const rakennukset =
  kiinteisto?.rakennukset_fulls ||
  kiinteisto?.rakennukset ||
  [];

console.log("🔥 MELU rakennusData:", kiinteisto);
console.log("🔥 MELU rakennukset:", rakennukset);

rakennukset.forEach((rakennus, index) => {
  console.log(`🔥 MELU rakennus ${index}:`, rakennus);
  console.log(
    `🔥 MELU aluetiedot ${index}:`,
    rakennus?.aluetiedot
  );
  console.log(
    `🔥 MELU Melutasot ${index}:`,
    rakennus?.aluetiedot?.Melutasot
  );
});
  // Collect noise data from all buildings.
  // Supports both:
  // aluetiedot.Melutasot.value
  // and direct Melutasot / melutasot fields.
  const kaikkiMelutasot = rakennukset.flatMap(rakennus => {
    return (
      rakennus?.aluetiedot?.Melutasot?.value ||
      rakennus?.aluetiedot?.Melutasot ||
      rakennus?.aluetiedot?.melutasot ||
      rakennus?.Melutasot ||
      []
    );
  });

  // Remove duplicates
  const melutasot = [];
  const seen = new Set();

  kaikkiMelutasot.forEach(item => {
    const key = [
      item?.lähde || "",
      item?.ajanjakso || "",
      item?.melutaso || ""
    ].join("|");

    if (!seen.has(key)) {
      seen.add(key);
      melutasot.push(item);
    }
  });

  return (
    <div
      style={{
        border: "1px solid #ddd",
        borderRadius: "4px",
        overflow: "hidden"
      }}
    >
      <div
        style={{
          backgroundColor: GREEN,
          color: WHITE,
          fontWeight: "bold",
          padding: "8px 10px"
        }}
      >
        Melutasot
      </div>

      {melutasot.length === 0 ? (
        <div
          style={{
            padding: "10px",
            backgroundColor: LIGHT_GREY
          }}
        >
          Kohteelle ei löytynyt melualuetietoja.
        </div>
      ) : (
        <div>
          {melutasot.map((item, index) => (
            <div
              key={`${item.lähde}-${item.ajanjakso}-${item.melutaso}-${index}`}
              style={{
                backgroundColor:
                  index % 2 === 0
                    ? LIGHT_GREY
                    : WHITE,
                padding: "10px"
              }}
            >
              <div>
                <strong>Melulähde:</strong>{" "}
                {item.lähde || "–"}
              </div>

              <div>
                <strong>Ajanjakso:</strong>{" "}
                {item.ajanjakso || "–"}
              </div>

              <div>
                <strong>Melutaso:</strong>{" "}
                {item.melutaso
                  ? `${item.melutaso} dB`
                  : "–"}
              </div>

              {item.aineisto && (
                <div>
                  <strong>Aineisto:</strong>{" "}
                  {item.aineisto}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}